/** Capacidades de producto según perfil de empresa (rotacion | estado_funcional). */

export function capabilitiesFromUser(user) {
    const role = String(user?.rol || user?.role || '').toLowerCase();
    const isSuperAdmin = role === 'superadmin';
    const profile = String(user?.solutionProfile || user?.capabilities?.solutionProfile || 'rotacion')
        .toLowerCase()
        .replace(/-/g, '_');
    const ef = profile === 'estado_funcional';
    // Superadmin valida todos los escenarios CID y el hub EF con independencia
    // del tenant “casa” (suele ser rotación / plataforma).
    return {
        solutionProfile: ef ? 'estado_funcional' : 'rotacion',
        showEstadoFuncional: isSuperAdmin || (user?.capabilities?.showEstadoFuncional ?? ef),
        showCidScenariosExtended:
            isSuperAdmin || (user?.capabilities?.showCidScenariosExtended ?? ef),
        efModulesEnabled: isSuperAdmin || (user?.capabilities?.efModulesEnabled ?? ef),
    };
}
